import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getUserClaims } from 'features/application/application-slice';
import { styled, useTheme } from '@mui/material/styles';
import { get_all_curatedSeriesList } from 'features/curatedSeriesList/curatedSeriesList-slice';
import { ProcessedMediaStates } from "models";
import { ResolveUrl, ResolvePath, ResolveStorageUrl, GetCachedUrls } from "features/firebase-app";
import { get_all_approvedMedia, is_approvedMedia_busy } from 'features/approvedMedia/approvedMedia-slice';
import { useBrowserInfo, useDebounce, useStutter, useInterval, useWatchRealTimeDB, useLocalId, mobileAndTabletCheck, useQueryParam } from 'components/utility';
import { get_all_approvedSeries, is_approvedSeries_busy } from "features/approvedSeries/approvedSeries-slice";
import { get_all_watchingProfileMetric } from 'features/watchingProfileMetric/watchingProfileMetric-slice';
import rq from 'components/RedQuick';
import React from "react";
import TitleService from "title-service";
import { MediaStatus, Views } from "features/enumerations";
import { get_selected_profile } from "features/profile/profile-slice";
import { get_selected_device } from "features/device/device-slice";
import { get_selected_coherentScreen } from "features/coherentScreen/coherentScreen-slice";
import { get_all_curatedMediaList } from "features/curatedMediaList/curatedMediaList-slice";
import { get_all_series, is_series_busy } from "features/series/series-slice";
import { get_all_media, is_media_busy } from "features/media/media-slice";
import LinearIndeterminate from "./LinearIndeterminate";

export default function PlaywatchSearch(props: any) {
    const theme = useTheme();
    const navigate = useNavigate();
    const searchValue = useQueryParam('query')
    let series = useSelector(get_all_series);
    let medias = useSelector(get_all_media);
    let approvedSeries_list = useSelector(get_all_approvedSeries);
    let watchingProfileMetric_list = useSelector(get_all_watchingProfileMetric);
    let approvedMedia_list = useSelector(get_all_approvedMedia);
    const browserInfo = useBrowserInfo();
    let profile = useSelector(get_selected_profile);
    const [urlUpdated, setUrlUpdated] = React.useState(null);
    let coherentScreen = useSelector(get_selected_coherentScreen);
    const [previewDicMetric, setPreviewDicMetric] = React.useState(null);
    const [watchingMediaDicArgs, setWatchingMediaDicArgs] = React.useState(null);
    const componentRef: React.Ref<HTMLDivElement> = React.useRef(null);
    const [viewPreviewObject, setViewPreviewObject] = React.useState(null);
    const componentRef_size = rq.useContainerSize(componentRef);
    let device = useSelector(get_selected_device);
    const approvedMedia_busy = useSelector(is_approvedMedia_busy);
    const approvedSeries_busy = useSelector(is_approvedSeries_busy);
    const series_busy = useSelector(is_series_busy);
    const medias_busy = useSelector(is_media_busy)
    const busy = approvedMedia_busy || approvedSeries_busy || series_busy || medias_busy;

    function getSrc(location: string, url: string, size: number) {
        let states: ProcessedMediaStates[] = [];
        approvedSeries_list.find((approved_series) => {
            if (approved_series?.processedSeries?.states) {
                states.push(...approved_series?.processedSeries?.states?.filter(st => {
                    let found = st.sourceLocation === location;
                    return found;
                }));
            }
        });
        if (!states.length) {
            approvedMedia_list.find((approved_media) => {
                if (approved_media?.processedMedia?.states) {
                    states.push(...approved_media?.processedMedia?.states?.filter((st) => {
                        let found = st.sourceLocation === location;
                        return found;
                    }))
                }
            })
        }
        if (states.length) {
            states = states.sort((a, b) => {
                return Math.abs(a.width - size) - Math.abs(b.width - size);
            });
            let state = states[0];
            let cached_url = GetCachedUrls(state.location);
            if (!cached_url) {
                ResolveStorageUrl(state.location).then((res) => {
                    if (res) {
                        setUrlUpdated((urlUpdated || 0) + 1);
                    }
                });
            }
            else {
                return cached_url;
            }
            if (mobileAndTabletCheck()) {
                return null;
            }
        }
        return url;
    }
    function modelComponent(): any {
        return (
            (() => {

                let mylist: any = [];
                let mysections: string[] = [];
                mylist.push(...approvedSeries_list.filter((approvedSeries) => {
                    let serie = approvedSeries.series;
                    if (searchValue) {
                        let s = `${searchValue}`.toLowerCase();
                        return (`${serie.name}`.indexOf(s) !== -1 ||
                            `${serie.description}`.indexOf(s) !== -1 ||
                            (serie.genre || []).some(v => `${JSON.stringify(v)}`.toLowerCase().indexOf(s) !== -1) ||
                            (serie.tags || []).some(v => `${JSON.stringify(v)}`.toLowerCase().indexOf(s) !== -1) ||
                            (serie.genre || []).some(v => `${JSON.stringify(v)}`.toLowerCase().indexOf(s) !== -1)) &&
                            (serie.mediaStatus === MediaStatus.Approved);
                    }
                    return false;
                }).map((approvedSeries) => {
                    let serie = approvedSeries.series;

                    let sized_video_url = getSrc(serie.titleMediaLocation, serie.titleMediaUrl, ((componentRef_size?.width || 0) / 8) || 200);

                    let sized_url = getSrc(serie.titleMediaImageLocation, serie.titleMediaImageUrl, ((componentRef_size?.width || 0) / 8) || 200);
                    if (!sized_url) {
                        return null;
                    }
                    let foundWatchingPreviewProfileMetric = watchingProfileMetric_list.find(v => v.seriesId === serie.id && v.currentPosition)
                    return ({
                        color: 'transparent', component: <rq.DisneyComponent
                            panelStyle={{
                                ['--hover-color']: theme?.palette?.dark[900] || '#ffffff'
                            }}
                            onPlaying={(args) => {
                                setWatchingMediaDicArgs({
                                    ...(watchingMediaDicArgs || {}),
                                    [serie.id]: {
                                        ...browserInfo,
                                        ...args,
                                        device: device?.id,
                                        profile: profile?.id,
                                        series: serie.id,
                                        media: null
                                    }
                                });
                                let viewedSections = [];
                                if (previewDicMetric && previewDicMetric[serie.id]) {
                                    viewedSections = previewDicMetric[serie.id].viewedSections;
                                }
                                else {
                                    viewedSections = new Array(100).fill(0);
                                }
                                if (args.duration) {
                                    let index = Math.round(100 * args.currentTime / args.duration);
                                    viewedSections[index] = 1;
                                    if (args.duration < 100) {
                                        if (index > 0) {
                                            viewedSections[index - 1] = 1;
                                        }
                                        if (index < 99) {
                                            viewedSections[index + 1] = 1;
                                        }
                                    }
                                    setPreviewDicMetric({
                                        ...(previewDicMetric || {}),
                                        [serie.id]: {
                                            seriesId: serie.id,
                                            mediaId: null,
                                            profileId: profile?.id,
                                            viewedSections: [...viewedSections],
                                            currentPosition: 0,
                                        }
                                    });
                                }
                            }}
                            onViewing={() => {
                                setViewPreviewObject({
                                    ...browserInfo,
                                    device: device?.id,
                                    profile: profile?.id,
                                    series: serie.id,
                                    media: null
                                });
                            }}
                            videoUrl={sized_video_url || serie.titleMediaUrl}
                            title={serie.name}
                            imageSrc={sized_url || serie.titleMediaImageUrl}
                            altText={serie.name}
                            currentPosition={foundWatchingPreviewProfileMetric?.currentPosition || 0}
                            onPlay={() => {
                                console.log('play movie')
                                navigate(`/${Views.Watch}/${serie?.id}`)
                            }} onOpen={() => {
                                console.log('open');
                                navigate(ResolvePath(`/${getLocationPath()}/${coherentScreen?.id}/${serie?.id}`));
                            }} />
                    })
                }).filter(x => x));

                mylist.push(...approvedMedia_list.filter(x => !x.hidden).filter((approvedMedia) => {
                    let serie = approvedMedia.media;
                    if (searchValue) {
                        let s = `${searchValue}`.toLowerCase();
                        return (`${serie.name}`.toLowerCase().indexOf(s) !== -1 ||
                            `${serie.description}`.toLowerCase().indexOf(s) !== -1 ||
                            (serie.tag || []).some(v => `${JSON.stringify(v)}`.toLowerCase().indexOf(s) !== -1)) &&
                            (serie.mediaStatus === MediaStatus.Approved);
                    }
                    return false;
                }).map((approvedMedia) => {
                    let mediaItem = approvedMedia.media;
                    let sized_url = '';
                    let sized_video_url = '';
                    sized_video_url = getSrc(mediaItem.mediaPreviewLocation, mediaItem.mediaPreviewUrl, ((componentRef_size?.width || 0) / 8) || 200);

                    sized_url = getSrc(mediaItem.thumbnailLocation, mediaItem.thumbnail, ((componentRef_size?.width || 0) / 8) || 200);
                    if (!sized_url) {
                        return null;
                    }
                    let foundWatchingPreviewProfileMetric = watchingProfileMetric_list.find(v => v.mediaId === mediaItem.id)
                    return {
                        video: sized_video_url || mediaItem.mediaPreviewUrl || mediaItem.mediaRel,
                        title: mediaItem.name,
                        imageSrc: sized_url || mediaItem?.thumbnail,
                        altText: mediaItem.name,
                        id: mediaItem.id,
                        currentPosition: foundWatchingPreviewProfileMetric?.currentPosition || 0
                    }
                }).filter(x => x).map((t) => {
                    return ({
                        color: 'transparent', component: <rq.DisneyComponent
                            panelStyle={{
                                ['--hover-color']: theme?.palette?.dark[900] || '#ffffff'
                            }}
                            onPlaying={(args) => {
                                setWatchingMediaDicArgs({
                                    ...(watchingMediaDicArgs || {}),
                                    [t.id]: {
                                        ...browserInfo,
                                        ...args,
                                        device: device?.id,
                                        profile: profile?.id,
                                        media: t.id,
                                        series: null,
                                        currentPosition: args.currentTime / args.duration,
                                    }
                                });
                                if (args.duration) {

                                    let viewedSections = [];
                                    if (previewDicMetric && previewDicMetric[t.id]) {
                                        viewedSections = previewDicMetric[t.id].viewedSections;
                                    }
                                    else {
                                        viewedSections = new Array(100).fill(0);
                                    }
                                    let index = Math.round(100 * args.currentTime / args.duration);
                                    viewedSections[index] = 1;
                                    if (args.duration < 100) {
                                        if (index > 0) {
                                            viewedSections[index - 1] = 1;
                                        }
                                        if (index < 99) {
                                            viewedSections[index + 1] = 1;
                                        }
                                    }
                                    setPreviewDicMetric({
                                        ...(previewDicMetric || {}),
                                        [t.id]: {
                                            mediaId: t.id,
                                            seriesId: null,
                                            profileId: profile?.id,
                                            viewedSections: [...viewedSections],
                                            currentPosition: args.currentTime / args.duration,
                                        }
                                    })
                                }

                            }}
                            onViewing={() => {
                                setViewPreviewObject({
                                    ...browserInfo,
                                    device: device?.id,
                                    profile: profile?.id,
                                    series: null,
                                    media: t.id
                                });
                            }}
                            currentPosition={t?.currentPosition || 0}
                            videoUrl={t.video}
                            title={t.title}
                            imageSrc={t.imageSrc}
                            altText={t.altText}
                            onPlay={() => {
                                console.log('play movie')
                                navigate(`/${Views.Watch}/inde/${t?.id}`)
                            }} onOpen={() => {
                                console.log('open');
                                navigate(ResolvePath(`/${getLocationPath()}/${coherentScreen?.id}/${t?.id}`));
                            }} />
                    })
                }));
                let itemsPerSlide = Math.min(Math.max(Math.floor(componentRef_size.width / 1500 * 5), 1), 6);
                let chunks = [];
                let chunkSection = [];
                for (let i = 0; i < mylist.length; i += itemsPerSlide) {
                    chunks.push(mylist.slice(i, i + itemsPerSlide));
                    chunkSection.push(' ')
                }
                const lists = [...chunks]; //, ...(Array.from({ length: 6 }).map(() => getList()))
                const sections = [...chunkSection]; // , ...Array.from({ length: 6 }).map((_: any, i: number) => `Section ${i}`)
                return (
                    <>
                        <div style={{ bottom: 0, position: 'absolute', width: `100vw` }}>
                            <LinearIndeterminate visible={busy} />
                        </div>
                        <div style={{ overflow: 'hidden', paddingTop: '15rem', paddingBottom: '15rem' }}>
                            <div style={{ position: 'relative', zIndex: 10 }} ref={componentRef}>
                                <div style={{ position: 'relative' }}>
                                    <rq.RedQuickLoLoList
                                        lists={lists}
                                        sections={sections}
                                        itemsPerSlide={itemsPerSlide}
                                        itemContainerCls="lolo__panel__container" />
                                </div>
                            </div>
                        </div>
                    </>
                );
            })()
        )
    }

    function getLocationPath(): string {
        if (location.href.indexOf(Views.PreviewCoherentScreen) !== -1) {
            return Views.PreviewCoherentScreen
        }
        return Views.Home;
    }

    let output_modelComponent = modelComponent();
    return (
        <>
            {output_modelComponent}
        </>
    )
}
